import useDefinedContext from "hooks/useDefinedContext";
import SetDataVisualizationTypeContext from "../contexts/SetDataVisualizationTypeContext";

function useSetDataVisualizationType() {
  return useDefinedContext(SetDataVisualizationTypeContext);
}
export default useSetDataVisualizationType;
